import { create, w, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';

import { Tooltip, Orientation } from '@dojo/widgets/tooltip';
import { subscribe, publish } from '@holmescorp/pub-sub';
import { Keys } from '@holmescorp/common';

import { Icon } from '../icon';

// import { Messages, Bundle } from '@dojo/framework/i18n/i18n';
// import { LocalizedMessages } from '@dojo/framework/core/mixins/I18n';
// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { ActionButton } from './action-button';

// import css from '../css/speed-dial.m.css';

export interface MenuActionProperties {
	onClick: () => void;
	onFocus?: () => void;
	shouldFocus?: boolean;
	altText?: string;
	ttText?: DNode;
	faname: string;
	xqa?: string;
	isHighlighted?: boolean;
}

interface MenuActionIcache {
	ttopen: boolean;
}

const icache = createICacheMiddleware<MenuActionIcache>();
const factory = create({ icache, theme }).properties<MenuActionProperties>();

export const MenuAction = factory(({ id, properties, middleware: { icache } }) => {
	const { onClick, onFocus, shouldFocus = false, altText, ttText, faname, xqa, isHighlighted = false } = properties();
	const ttActive = () => {
		onFocus && onFocus();
		icache.set('ttopen', true);
	};
	const ttHidden = () => icache.set('ttopen', false);

	// hide all the tooltips except the one that was clicked (or else there's an overlap)
	subscribe('menuAction/hideAllTooltips', (action, sourceId) => {
		if (sourceId !== id) {
			ttHidden();
		}
	});

	let timeoutId: number;

	return w(Tooltip, { open: icache.getOrSet('ttopen', false), orientation: Orientation.bottom }, [
		{
			content: v('span', { onmouseover: () => clearTimeout(timeoutId), onmouseout: ttHidden }, [ttText]),
			trigger: w(
				ActionButton,
				{
					aria: {
						label: altText || ''
					},
					shouldFocus,
					size: 'small',
					isAction: true,
					onClick,
					onOver: () => {
						publish('menuAction/hideAllTooltips', id);
						ttActive();
					},
					onOut: () => {
						timeoutId = setTimeout(() => ttHidden(), 500);
					},
					onFocus: ttActive,
					onBlur: ttHidden,
					onKeyDown: (event: KeyboardEvent) => {
						if (event.key === Keys.Escape) {
							ttHidden();
						}
					},
					isHighlighted
				},
				[w(Icon, { faname, altText, xqa })]
			)
		}
	]);
});
